<template>
  <div class="material-workorder" v-loading="loading">
     <el-form :model="formData" class="form">
            <el-row :gutter="10">
                <el-col :span="8">
                    <el-form-item>
                        <el-select
                            v-model="formData.config"
                            placeholder="请选择"
                            style="width:100%"
                        >
                            <el-option
                                v-for="item in global.fileConfigList"
                                :key="item.id"
                                :value-key="item.id"
                                :label="item.format_text"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item>
                        <el-input
                            placeholder="请输入素材或项目名称搜索"
                            v-model="formData.keyWords"
                            style="width: 100%"
                            @keyup.enter.native="()=>refreshList()"
                        >
                            <el-button slot="append" icon="el-icon-search" @click="()=>refreshList()"></el-button>
                        </el-input>
                    </el-form-item>
                   
                </el-col>
                <el-col :span="6">
                    <el-form-item>
                        <el-select v-model="formData.state" placeholder="素材状态"  clearable>
                            <el-option
                                v-for="item in global.searchConfigData.material_status_map"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="11">
                  <el-form-item>
                    <ESelect
                        class="work-select"
                        v-model="formData.workId"
                        style="width: 100%"
                        multiple
                        filterable
                        remote
                        collapse-tags
                        reserve-keyword
                        clearable
                        placeholder="工单：请输入工单ID或名称搜索"
                        :remote-method="handleRemoteMethod"
                        ref="select"
                        :loading="remoteLoading">
                        <p class="option-select">
                            <el-button type="text" @click="handleCheckAll">全选</el-button>
                            <el-button type="text" @click="()=>formData.workId=[]">取消全选</el-button>
                        </p>
                        <el-option
                            v-for="item in workList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </ESelect>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                     <el-form-item>
                        <ESelect style="width: 100%" v-model="formData.plat_id" multiple clearable collapse-tags placeholder="素材渠道" filterable>
                            <el-option
                                v-for="item in global.searchConfigData.plat_map"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                </el-col>
                <el-col :span="3" class="tar">
                    <el-dropdown placement="bottom" ref="dropdownRef" @command="handleOptCommand" :hide-on-click="false">
                        <el-button  type="primary" plain >操作</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="all" >
                                <div class="opt-item">本页全部添加</div>
                            </el-dropdown-item>
                            <el-dropdown-item  divided>
                                <div class="opt-item">
                                    添加前N个
                                    <el-input 
                                        v-model.number="formData.firstN" 
                                        class="mr8 ml8" style="width:50px" size="mini" 
                                        @input="(value)=>formData.firstN=value.replace(/[^0-9]|^0$/g,'')"
                                    /> 
                                    <i 
                                        class="icon text-color-success" 
                                        @click="handleAddMaterial('firstN')"
                                        :class="addLoading?'el-icon-loading':'el-icon-success'"
                                    />
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item  divided>
                                <div class="opt-item">
                                    <div class="label">
                                        <p>添加前N个</p>
                                        <p>未使用素材</p>
                                    </div>
                                    <el-input 
                                        v-model.number="formData.noUseFirstN" 
                                        class="mr8 ml8" style="width:50px" size="mini"
                                        @input="(value)=>formData.noUseFirstN=value.replace(/[^0-9]|^0$/g,'')"
                                     /> 
                                    <i 
                                        class="icon text-color-success" 
                                        @click="handleAddMaterial('noUseFirstN')"
                                        :class="addLoading?'el-icon-loading':'el-icon-success'"
                                    />
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
        </el-form>
     <div class="content mt20" :id="contentId">
        <template v-if="list.length">
            <div class="list" >
                <template v-for="item in list">
                    <div class="list-item" :key="item.id">
                        <WorkOrder :params="item" @add="()=>handleAddItemMaterial(item)"/>
                    </div>
                </template>
            </div>
            <el-pagination
                class="tal"
                layout="prev, pager, next"
                :current-page.sync="pageNum"
                :page-size="pageSize"
                @current-change="()=>getList()"
                :total="total">
            </el-pagination>
        </template>
        <div v-else class="no_data">暂无数据</div>
    </div>
  </div>
</template>

<script>
import WorkOrder from './workOrder.vue'
import util from '@/libs/utils'
import { getWorkMaterialListApi, getWorkOrderListApi } from '@/api'
import _ from 'lodash';
import { FILE_TYPE } from './constant'
import busMixin from '@/views/mixins/busMixin'
export default {
    components: { WorkOrder },
    inject:[ 'global' ],
    mixins: [ busMixin ],
    data() {
        return {
            remoteLoading: false,
            workList: [],
            list: [],
            formData: {
                workId: [],
                config: '',
                keyWords: '',
                firstN: '',
                noUseFirstN: '',
                plat_id: [],
                state: ''
            },
            addLoading: false,
            loading: false,
            pageNum: 1,
            pageSize: 30,
            total: 0,
            contentId: `_${util.randomString(20)}`,
            cancel: null,
        }
    },
    mounted() {
        const listFn = () =>{
          this.$nextTick(()=> {
           try {
            this.formData.config =  this.global.fileConfigList[0].id;
           } catch (error) {
            this.formData.config = ''
           }
          })
        };
        this.$bus.$on('updateListData',listFn);
        this.$once('hook:beforeDestroy', () => {
            this.$bus.$off('updateListData', listFn)
        });
        this.createBus('updataFormNameData', (data)=> {
            if(data) {
                this.$nextTick(()=> {
                    this.formData.keyWords = data;
                    this.refreshList();
                })
            }
        })
    },
    methods: {
        refreshList() {
            this.pageNum = 1;
            this.getList()
        },
        handleCheckAll() {
            const ids = this.formData.workId;
            this.workList.map(v=>v.value);
            this.formData.workId = [
                ...new Set([
                    ...ids,
                    ...this.workList.map(v=>v.value)
                ])
            ]
        },
        async handleRemoteMethod(search) {
            try {
                this.remoteLoading = true;
                const conf = [];
                conf.push( this.getParams(this.configData))
                const params = {
                    plat_id: 10,
                    conf,
                    search,
                    app_id: this.global.appList.map(v=>v.value),
                }
               const { data } =  await getWorkOrderListApi(params);
                this.workList = data.map(v=> {
                    return {
                        ...v,
                        value: v.id,
                        label: `工单：${v.work_order_name}(${v.id})`
                    }
                })
            } catch (error) {
                console.log(error, '搜索工单错误');
                
                this.$message.error(error.info)
            } finally {
                this.remoteLoading = false
            }
        },
        handleOptCommand(type) {
            if (this.addLoading) {
                return
            }
            if (type === 'all') {
                this.$refs.dropdownRef.hide();
                if (this.list.length) {
                    this.$nextTick(()=> {
                        this.global.handleSelectData(true, this.list.map(v=> {
                            return {
                                ...v,
                                key: this.global.currentKey, config: this.configData
                            }
                        }));
                    })
                }else {
                    this.$message.error('无可添加素材')
                }
            }
        },
        async handleAddMaterial(type) {
            if (this.addLoading) {
                return
            }
            this.addLoading = true
            try {
                const p =this.getConfigParams();
                const params = { ...p };
                const num = this.formData[type];
                if (!num) {
                    return this.$message.error('请输入添加数量');
                }
                if ('firstN' === type) {
                    params.num = num;
                    // noUseFirstN
                }else {
                    params.not_use_num = num;
                }
                const { data } = await getWorkMaterialListApi(params);
                if(!data || data.length ===0) {
                    return this.$message.error('无可添加的素材')
                };
                this.global.handleSelectData(true, data.map(v=> {
                    return {
                        ...v,
                        key: this.global.currentKey, config: this.configData
                    }
                }));
                this.formData[type] = '';
                if (data.length < num) {
                    this.$message.error(`素材数量不足【${num}】，已将满足要求的素材全部添加`)
                }
               
            } catch (error) {
                console.log(error, '添加失败');
                this.$message.error(error.info || error.message)
            }finally {
                this.addLoading = false
            }
        },
        handleAddItemMaterial(data) {
            const { config } = this.formData;
            this.global.handleSelectData(true, { ...data, key: this.global.currentKey, config: this.configData } )
        },
        async getList() {
            this.cancel && this.cancel();
            try {
                this.loading = true;
                const p =this.getConfigParams();
                const params = {
                    ...p,
                    pn: this.pageNum,
                    rn: this.pageSize
                };
                const { data } = await getWorkMaterialListApi(params, (c)=> this.cancel = c);
                if (params.pn=== this.pageNum) {
                    this.list = data.list;
                    this.total = data.totalCnt;
                }
                this.loading = false
            } catch (error) {
                console.log(error.info);
                this.loading = false
            } finally {
                this.cancel = null;
                
            }
        },
        getConfigParams() {
            const { config } = this.formData;
            const conf = [];
            conf.push( this.getParams(this.configData))
            const {  keyWords, workId, plat_id , state } = this.formData;
            return { 
                conf,
                plat_id: 10,
                search: keyWords,
                order_id: workId,
                search_plat_id: plat_id,
                is_used: state,
                app_id: this.global.appList.map(v=>v.value),
            }
        },
        getParams(configData = {}) {
            const {
                material_type, conf_format, conf_length,
                conf_size, conf_resolution, min_conf_length,
                creative_size_element_name, min_resolution, max_resolution,file_format,
                resolution_ratio,width,height,
                
            } = configData;
           return {
                conf_format,conf_size, 
                conf_resolution: min_resolution? min_resolution: `${width}*${height}`,
                max_conf_resolution: max_resolution,
                config_type: creative_size_element_name ==='video' ? '2':'1',
                conf_format: file_format,
                resolution_ratio,
                conf_length
            }
        },
    },
    computed: {
        searchParams() {
            const { config, workId, plat_id , state } = this.formData;
            return {
                config, workId, plat_id,state
            }
        },
        configData() {
            const { config } = this.formData;
            return this.global.fileConfigList.find(v=> v.id === config)
        }
    },
    watch: {
        searchParams: {
            handler() {
                this.refreshList()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.opt-item {
    padding: 6px 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .label {
        p {
            line-height: 1;
        }
    }
    .icon {
        font-size: 20px;
    }
}
.no_data {
    min-height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #909399;
}
.material-workorder {
    &::v-deep {
        .el-form-item {
            margin-bottom: 8px;
        }
        .work-select .el-tag {
            max-width: 60%
        }
    };
    height: 100%;
    display: flex;
    flex-direction: column;
    .form {
        height: 60px;
    }
    .content {
        flex: 1;
        height: 0;
        overflow: auto;
    }
}
.list {
    display: flex;
    flex-wrap: wrap;
}

</style>